import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

const baseUrl = `${import.meta.env.VITE_COMMUNICATION_SERVICE_URL}/communication`;
export const axiosCommunication = buildMakeUseAxios(baseUrl);
export const axiosCommunicationInstance = buildAxiosInstance(baseUrl);
